import { Injector, inject, provideAppInitializer } from '@angular/core';
import { AccountRepository, setStatusBar } from '@timechef/features/account/state';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppInsightsService, GoogleAnalyticsService } from '../analytics';

function appInitFactory(accountRepo: AccountRepository, appInsights: AppInsightsService, injector: Injector): () => Promise<void> {
  return async () => {
    console.log('config loaded');
    try {
      appInsights.init(environment.appInsights.instrumentationKey, environment.appInsights.trackPageView);
      // We use Injector.get to fetch GoogleAnalyticsService AFTER configService.load because of GA_CONFIG_PROVIDERS
      await injector.get(GoogleAnalyticsService).init();
    } catch (e) {
      console.error(e);
    }

    try {
      await lastValueFrom(accountRepo.instance.initialized$);
      const theme = accountRepo.getTheme();
      const isDark = theme === 'dark';
      if (isDark) {
        document.body.classList.add('dark');
      }

      setStatusBar(isDark, true);
    } catch (e) {
      console.error(e);
    }
  };
}

export const appInitializer = provideAppInitializer(() => {
  const initializerFn = appInitFactory(inject(AccountRepository), inject(AppInsightsService), inject(Injector));
  return initializerFn();
});
